import { render } from "./DefaultButton.vue?vue&type=template&id=222ea388"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__